<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Kategorie - Upravit <span class="utils__link--underlined text-primary">#{{ this.id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <h4 class="text-black mt-4 mb-3"><strong>Nastavitelné podle jazyka</strong></h4>
        <a-form-item
          :validate-status="error('cle_name') ? 'error' : ''"
          :help="error('cle_name') || ''"
          label="Název"
        >
          <a-input placeholder="Název" v-decorator="['cle_name', {rules: [{max: 70, message: 'Název nemůže být delší než 70 znaků!'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          :validate-status="error('cle_description') ? 'error' : ''"
          :help="error('cle_description') || ''"
          label="Popisek"
        >
          <a-input :autoSize="{ minRows: 4, maxRows: 10 }" type="textarea" placeholder="Popisek" v-decorator="['cle_description']"/>
        </a-form-item>

        <h4 class="text-black mt-4 mb-3"><strong>Ostatní</strong></h4>

        <a-form-item
          :label="'Skupiny (%)'"
          :required="true"
        >
          <a-row>
            <a-col :offset="2">
              <a-form-item
                v-for="(item, index) in groups"
                :key="'grp'+index"
                :label="item.grp_name"
                :validate-status="error(`group[${item.grp_id}]`) ? 'error' : ''"
                :help="error(`group[${item.grp_id}]`) || ''"
              >
                <a-input-number :step="0.01" style="width: 100%;" :min="0" :max="100" v-decorator="[`group[${item.grp_id}]`, { validateTrigger: ['change', 'blur'], rules: [{ required: true, message: 'Skupina musí být vyplněna!'}]}]"
                                :placeholder="item.grp_name"
                >
                </a-input-number>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form-item>

        <a-form-item label="Zveřejnit?">
          <a-checkbox v-decorator="['cey_is_active', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <my-form-image-item
          title="Malý obrázek"
          decorator-name="existing_thumb"
          :image="thumbImage"
          :image-next-count="thumbImageNextCount"
          :images="thumbImages"
          :on-image-switch-change="onThumbImageSwitchChange"
          :on-next-images-click="onNextThumbImagesClick"
          :form="form"
        ></my-form-image-item>

        <my-form-image-item
          title="Hlavní obrázek"
          decorator-name="existing_breadcrumb"
          :image="breadcrumbImage"
          :image-next-count="breadcrumbImageNextCount"
          :images="breadcrumbImages"
          :on-image-switch-change="onBreadcrumbImageSwitchChange"
          :on-next-images-click="onNextBreadcrumbImagesClick"
          :form="form"
        ></my-form-image-item>

        <a-form-item
          label="Vyber rodiče kategorie"
        >
          <a-tree-select :allowClear="true" placeholder="-- Vyber rodiče kategorie --" :loading="item.cey_cey_id.loading" :treeData="treeData" v-decorator="['cey_cey_id']"></a-tree-select>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'
import myFormImageItem from '@/components/MyComponents/Gallery/my-form-image-item'
import breadcrumbImageMixin from '@/components/MyComponents/Gallery/breadcrumb-image-mixin'
import thumbImageMixin from '@/components/MyComponents/Gallery/thumb-image-mixin'

export default {
  components: { ActionTools, LanguageTab, myFormImageItem },
  mixins: [breadcrumbImageMixin, thumbImageMixin],
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data: function () {
    return {
      hasErrors,
      dependencies: ['group_category_discounts', 'cey_cey_id'],
      id: this.$route.params.id,
      loading: false,
      treeData: [],
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/ecommerce/category',
          title: 'Seznam',
        },
      ],
      item: {
        thumb_image_id: null,
        breadcrumb_image_id: null,
        cey_cey_id: {
          active: null,
          loading: false,
        },
        group_category_discounts: {
          loading: false,
          active: [],
        },
        languages: [],
      },
      loaded: [],
    }
  },
  computed: {
    groups: function() {
      return this.$store.getters['group/active']
    },
    language: function() {
      return this.$store.getters['language/active']
    },
    detail: function() {
      return this.$store.getters['category/getDetail']
    },
    categories: function() {
      return this.$store.getters['category/currentLanguage']
    },
  },
  methods: {
    toTreeNodeData(data) {
      return data.map(x => {
        return {
          key: '' + x.cey_id,
          value: '' + x.cey_id,
          title: '#' + x.cey_id + ' | ' + (x.languages[0] !== undefined ? x.languages[0].pivot.cle_name : 'není nenastaveno'),
          children: this.toTreeNodeData(x.all_children),
        }
      })
    },
    initData() {
      this.loading = true
      this.dependencies.forEach((value) => {
        this.item[value].loading = true
      })
      Promise.all([
        this.$store.dispatch('category/getList'),
        this.$store.dispatch('group/getActive'),
        this.$store.dispatch('image/getList'),
        this.$store.dispatch('image/getOnlyBreadcrumbs'),
      ])
        .then(() => {
          this.initDetail()
        })
        .catch(() => {})
        .finally(() => {
          this.dependencies.forEach((value) => {
            this.item[value].loading = false
          })
          this.loaded.push(this.language)
          this.treeData = this.toTreeNodeData(this.categories)
          this.loading = false
        })
    },
    initDetail() {
      this.loading = true
      this.$store.dispatch('category/getOne', this.id)
        .then(() => {
          const oldItem = this.item
          this.item = Object.assign({}, this.detail)
          this.item.cey_cey_id = {
            loading: false,
            active: oldItem.cey_cey_id.active !== null ? oldItem.cey_cey_id.active : this.detail.cey_cey_id,
          }
          this.item.thumb_image_id = oldItem.thumb_image_id !== null ? oldItem.thumb_image_id : this.detail.thumb_image_id
          this.item.breadcrumb_image_id = oldItem.breadcrumb_image_id !== null ? oldItem.breadcrumb_image_id : this.detail.breadcrumb_image_id
          this.item.group_category_discounts = {
            loading: false,
            active: oldItem.group_category_discounts.active.length !== 0 ? oldItem.group_category_discounts.active : this.detail.group_category_discounts,
          }
          const currentDetailLang = this.$store.getters['category/currentLanguageDetail']
          this.form.getFieldDecorator('existing_thumb')
          this.form.getFieldDecorator('existing_breadcrumb')
          this.form.setFieldsValue({
            cle_name: currentDetailLang.cle_name,
            cle_description: currentDetailLang.cle_description,
            cey_cey_id: this.item.cey_cey_id.active !== null ? '' + this.item.cey_cey_id.active : undefined,
            existing_thumb: this.item.thumb_image_id,
            existing_breadcrumb: this.item.breadcrumb_image_id,
            cey_is_active: this.detail.cey_is_active,
          })
          this.item.group_category_discounts.active.forEach((value, key) => {
            this.form.getFieldDecorator(`group[${value.grp_id}]`)
            this.form.setFields({
              ['group[' + value.grp_id + ']']: { value: value.pivot.gct_discount },
            })
          })
          this.thumbImage.trigger = !this.thumbImage.trigger
          this.thumbImage.switch = this.item.thumb_image_id !== null
          if (this.thumbImage.selectedOne === undefined) {
            this.thumbImage.selectedOne = this.detail.thumb_image
          }
          this.breadcrumbImage.trigger = !this.breadcrumbImage.trigger
          this.breadcrumbImage.switch = this.item.breadcrumb_image_id !== null
          if (this.breadcrumbImage.selectedOne === undefined) {
            this.breadcrumbImage.selectedOne = this.detail.breadcrumb_image
          }
          this.form.validateFields()
        }).catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    getData() {
      return {
        thumb_image_id: this.form.getFieldValue('existing_thumb') === undefined ? null : parseInt(this.form.getFieldValue('existing_thumb')),
        breadcrumb_image_id: this.form.getFieldValue('existing_breadcrumb') === undefined ? null : parseInt(this.form.getFieldValue('existing_breadcrumb')),
        cey_cey_id: this.form.getFieldValue('cey_cey_id') === undefined ? null : parseInt(this.form.getFieldValue('cey_cey_id')),
        languages: this.item.languages.filter(x => x.cle_name !== undefined && x.cle_name.trim().length > 0),
        cey_is_active: this.form.getFieldValue('cey_is_active'),
        group_category_discounts: this.groups.map(x => { return { grp_id: x.grp_id, gct_discount: this.form.getFieldValue('group[' + x.grp_id + ']') } }),
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('category/put', { id: this.id, item: this.getData() })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleChange(oldLanguage) {
      const foundObj = { item: false }
      const newObj = {
        item: {
          lge_id: oldLanguage,
          cle_name: this.form.getFieldValue('cle_name'),
          cle_description: this.form.getFieldValue('cle_description') === undefined ? null : this.form.getFieldValue('cle_description'),
        },
      }
      this.item.languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.languages[key] = newObj.item
          foundObj.item = true
          return true
        }
      })
      if (!foundObj.item) {
        this.item.languages.push(newObj.item)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
    refreshComponent(id) {
      this.id = id
      this.thumbImage = {
        switch: false,
        search: '',
        page: 1,
        loaded: true,
        errors: [],
        selectedOne: undefined,
      }
      this.breadcrumbImage = {
        switch: false,
        search: '',
        page: 1,
        loaded: true,
        errors: [],
        selectedOne: undefined,
      }
      this.item = {
        thumb_image_id: null,
        breadcrumb_image_id: null,
        cey_cey_id: {
          active: null,
          loading: false,
        },
        group_category_discounts: {
          loading: false,
          active: [],
        },
        languages: [],
      }
      this.loaded = []
    },
  },
  created() {
    if (this.treeData.length === 0 && this.categories.length !== 0) {
      this.treeData = this.toTreeNodeData(this.categories)
    }
    if (this.language !== null && !this.loaded.includes(this.language)) {
      this.initData()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null && this.loaded.includes(oldValue)) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        if (!this.loaded.includes(this.language)) {
          this.initData()
        } else {
          this.treeData = this.toTreeNodeData(this.categories)
          const foundObj = { item: this.item.languages.find(x => x.lge_id === newValue) }
          let newObj
          if (foundObj.item === undefined) {
            newObj = {
              cle_name: undefined,
              cle_description: undefined,
            }
          } else {
            newObj = {
              cle_name: foundObj.item.cle_name,
              cle_description: foundObj.item.cle_description,
            }
          }
          this.form.setFieldsValue(newObj)
          if (!this.loaded.includes(this.language)) {
            this.initData()
          }
          this.form.setFieldsValue(newObj)
        }
        this.form.validateFields()
      }
    },
    categories() {
      this.treeData = this.toTreeNodeData(this.categories)
    },
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      if (this.language !== null) {
        this.initDetail()
      }
    },
  },
}
</script>
